import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  FormControl,
  Grid,
  OutlinedInput,
  InputAdornment,
  TextField,
  Typography,
  Stack,
} from "@mui/material";
import Select from "react-select";
import MenuItem from "@mui/material/MenuItem";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useState, useEffect } from "react";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import customStyles from "app/shared-components/SelectCustomStyle";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import moment from "moment";

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  "&.MuiCheckbox-root.Mui-checked": {
    color: "#ffa726",
  },
}));

const NominalLedgerFilter = (props) => {
  const { toggleFullScreen, handleSearch, handleChange } = props;
  const [company, setCompany] = useState("1");
  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedAccountType, setSelectedAccountType] = useState("ALL");
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [accountNo, setAccountNo] = useState("");
  const [accountName, setAccountName] = useState("");
  const [selectedVoucherType, setSelectedVoucherType] = useState("ALL");
  const [voucherTypeOptions, setVoucherTypeOptions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("EUR");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");

  const voucherTypeUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucherTypes}`;
  const accountTypeUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.accountTypes}`;

  useEffect(() => {
    const currencies = async () => {
      const currencyUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.currencies}`;
      const list = await OAuthService.getList(currencyUrl);
      if (list?.data) {
        const options = list?.data?._embedded?.currencies.map((data) => {
          props.setFilterData((prevValues) => ({
            ...prevValues,
            ["currency"]: data.name,
          }));
          return { label: data.name, value: data.name };
        });
        setCurrencyOptions(options);
      }
    };
    currencies();

    const partnerOpt = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
      const partners = await OAuthService.getList(
        url +
          `/search/findByCustomerTypes?customerTypes=FRANCHISE&customerTypes=NOLTEFZE`
      );
      const result = partners?.data?._embedded?.companies.map((value) => {
        props.setFilterData((prevValues) => ({
          ...prevValues,
          ["companyCode"]: value.id.toString(),
        }));
        return {
          label: value.name,
          value: value.id,
          refNumber: value.vendorCustomerRef,
        };
      });
      setCompanyOptions(result);
    };
    partnerOpt();

    const accountTypes = async () => {
      const types = await OAuthService.getList(accountTypeUrl);
      let vouchers = types?.data?._embedded?.accountTypes?.map((type) => {
        return {
          label: type.descripation,
          value:
            [
              { id: "HEAD", name: "HEAD" },
              { id: "GROUP", name: "GROUP" },
              { id: "GL", name: "GENERAL_LEDGER" },
              { id: "SL", name: "SUB_LEDGER" },
              { id: "L", name: "LEDGER" },
            ].find((i) => i.id === type.name)?.name || "",
          id: type?._links?.self?.href.split("/").pop(),
        };
      });
      vouchers = [{ label: "ALL", value: "ALL" }, ...vouchers];
      if (vouchers && vouchers.length > 0) {
        setAccountTypeOptions(vouchers);
      }
    };

    accountTypes();

    const voucherTypes = async () => {
      const types = await OAuthService.getList(voucherTypeUrl);
      let vouchers = types?.data?._embedded?.voucherTypes?.map((type) => {
        return {
          label: type.shortKey + " " + type.description,
          value: type.shortKey,
          id: type?._links?.self?.href.split("/").pop(),
        };
      });
      vouchers = [{ label: "ALL", value: "ALL", id: "ALL" }, ...vouchers];
      if (vouchers && vouchers.length > 0) {
        setVoucherTypeOptions(vouchers);
      }
    };

    voucherTypes();
  }, []);

  const CheckboxOption = ({ innerProps, label, isSelected }) => (
    <div {...innerProps}>
      <input type="checkbox" checked={isSelected} onChange={() => null} />
      <span style={{ marginLeft: "2px" }}>{label}</span>
    </div>
  );

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <div className="flex">
          <FormControl className="flex flex-row">
            <Grid container spacing={2}>
              <Grid item md={2} lg={2}>
                <Stack>
                  <label className="basis-0 float-left">*Company</label>
                  <Select
                    name="company"
                    value={
                      company &&
                      companyOptions &&
                      companyOptions.find(
                        (data) => Number(data.value) === Number(company)
                      )
                    }
                    isDisabled={true}
                    options={companyOptions}
                    onChange={(e) => {
                      handleChange(e, "company");
                    }}
                    styles={customStyles()}
                  />
                </Stack>
              </Grid>
              <Grid item md={2} lg={2}>
                {/*{console.log("Acc =>", accountTypeOptions)}*/}
                <Stack>
                  <label className="basis-0 float-left">*Account Type</label>
                  <Select
                    name="accountType"
                    value={
                      selectedAccountType &&
                      accountTypeOptions &&
                      accountTypeOptions.find(
                        (data) =>
                          Number(data.value) === Number(selectedAccountType)
                      )
                    }
                    // isDisabled={true}
                    options={accountTypeOptions}
                    onChange={(e) => {
                      handleChange(e, "accountType");
                    }}
                    styles={customStyles()}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {props.error === "accountType"
                      ? "This field is required"
                      : ""}
                  </Typography>
                </Stack>

                {/* <div className="mr-16">
                                    <label>Account Type</label>
                                    <StyledSelect
                                        className="w-full h-2.5 overflow-hidden"
                                        value={selectedAccountType}
                                        name="currency"
                                        onChange={(e) => { setSelectedAccountType(e.target.value); handleAccountTypeChange(e.target.value); console.log("clicked") }}
                                        variant="outlined"
                                    >
                                        {viewAccountType
                                            .map((val, index) => (
                                                <MenuItem
                                                    key={val}
                                                    value={val}
                                                    className="m-8 mt-0 rounded-lg"
                                                >
                                                    {val}
                                                </MenuItem>
                                            ))}
                                    </StyledSelect>
                                </div> */}
              </Grid>
              <Grid item md={2} lg={2}>
                <Stack>
                  <label className="basis-0 float-left">Account Number</label>
                  <TextField
                    className="w-[100%]"
                    type="text"
                    name="accountNo"
                    placeholder="Account No"
                    value={accountNo}
                    // onChange={(e) => { setAccountNo(e.target.value); handleChange(e) }}
                    onChange={(e) => {
                      setAccountNo(e.target.value);
                      handleChange(e, "accountNo");
                    }}
                    style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                    // onChange={handle}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
                <Typography className="text-[#f44336] text-sm ml-14">
                  {props.error === "accountNo" && accountNo === ""
                    ? "This field is required"
                    : ""}
                </Typography>
              </Grid>
              <Grid item md={2} lg={2}>
                <Stack>
                  <label className="basis-0 float-left">Account Name</label>
                  <TextField
                    className="w-[100%]"
                    type="text"
                    name="accountName"
                    placeholder="Account Name"
                    value={accountName}
                    // onChange={(e) => { setAccountName(e.target.value); handleChange(e) }}
                    onChange={(e) => {
                      setAccountName(e.target.value);
                      handleChange(e, "accountName");
                    }}
                    style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                    // onChange={handle}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
                <Typography className="text-[#f44336] text-sm ml-14">
                  {props.error === "accountName" && accountName === ""
                    ? "This field is required"
                    : ""}
                </Typography>
              </Grid>
              <Grid item md={2} lg={2}>
                <Stack className="ml-10">
                  <label className="basis-0 float-left">Voucher Type</label>
                  <Select
                    name="voucherType"
                    className="w-[100%]"
                    value={
                      selectedVoucherType &&
                      voucherTypeOptions.length > 0 &&
                      voucherTypeOptions.filter(
                        (list) => list.id === selectedVoucherType
                      )
                    }
                    // onChange={(e) => { setSelectedVoucherType(e.id); handleChange(e) }}
                    onChange={(e,action) => {
                      setSelectedVoucherType(action.action === "clear" ? "ALL":e?.id);
                      handleChange(e, "voucherType",action);
                    }}
                    options={voucherTypeOptions}
                    styles={customStyles("", "", "0px")}
                    components={{
                      Option: (optionProps) => (
                        <CheckboxOption
                          {...optionProps}
                          isSelected={optionProps.isSelected}
                        />
                      ),
                    }}
                    isClearable={selectedVoucherType !== "ALL"}
                  />
                </Stack>
                {/* <div className="mr-16">
                                    <label>Voucher Type</label>
                                    <StyledSelect
                                        className="w-full h-2.5 overflow-hidden"
                                        value={selectedVoucherType}
                                        name="currency"
                                        renderValue={(selected) => selected.join(', ')}
                                        onChange={(e) => {
                                            setSelectedVoucherType(
                                                On autofill we get a stringified value.
                                                typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value,
                                            ); handleVoucherTypeChange(e.target.value)
                                        }}
                                        variant="outlined"
                                        multiple
                                    >
                                        {viewVoucherType
                                            .map((val, index) => (
                                                <MenuItem
                                                    key={val}
                                                    value={val}
                                                    className="m-8 mt-0 rounded-lg"
                                                >
                                                    <CustomCheckbox checked={selectedVoucherType.indexOf(val) > -1} />
                                                    {val}
                                                </MenuItem>
                                            ))}
                                    </StyledSelect>
                                </div> */}
              </Grid>
              <Grid item md={2} lg={2}>
                <Stack>
                  <label className=" basis-0 float-left">*Currency</label>
                  {/* <FormControl sx={{ width: 200 }} > */}
                  <Select
                    name="currency"
                    value={
                      currencyOptions.length > 0 &&
                      selectedCurrency &&
                      currencyOptions.filter(
                        (data) => data.value === selectedCurrency
                      )
                    }
                    // error={validError.currency ? true : false}
                    onChange={(e) => {
                      setSelectedCurrency(e.value);
                      handleChange(e, "currency");
                    }}
                    isDisabled={false}
                    options={currencyOptions}
                    styles={customStyles()}
                  ></Select>
                  {/* </FormControl> */}
                  {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.currency) ? "This field is required" : validError.currency}</Typography> */}
                </Stack>
              </Grid>
              <Grid item md={2} lg={2}>
                <Stack>
                  <label className="basis-0 float-left">*Period From </label>
                  <CustomDatePicker
                    className="w-[100%]"
                    format={"dd-MM-yyyy"}
                    name={"startDate"}
                    value={periodFrom}
                    handleChange={(value) => {
                      setPeriodFrom(moment(value).format("YYYY-MM-DD"));
                      handleChange(value, "startDate");
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        InputLabelProps={{}}
                        {...params}
                        sx={{
                          backgroundColor: props.viewData && "#8080800f",
                        }}
                      />
                    )}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {props.error === "startDate" && periodFrom === ""
                      ? "This field is required"
                      : ""}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item md={2} lg={2}>
                <Stack>
                  <label className="basis-0 float-left">*Period To </label>
                  <CustomDatePicker
                    className="w-[100%]"
                    format={"dd-MM-yyyy"}
                    name={"endDate"}
                    value={periodTo}
                    handleChange={async (value) => {
                      setPeriodTo(moment(value).format("YYYY-MM-DD"));
                      handleChange(value, "endDate");
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        InputLabelProps={{}}
                        {...params}
                        sx={{
                          backgroundColor: props.viewData && "#8080800f",
                        }}
                      />
                    )}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {props.error === "endDate" && periodTo === ""
                      ? "This field is required"
                      : ""}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item md={3} lg={3}>
                <FormGroup className="mt-16 mr-0">
                  <FormControlLabel
                    style={{
                      "& .MuiFormControlLabel-label": { fontSize: "1rem" },
                    }}
                    control={
                      <CustomCheckbox
                        name="includeOpeningBalance"
                        onChange={(e) => handleChange(e, "checkbox")}
                      />
                    }
                    label="Include operning balance"
                  />
                </FormGroup>
              </Grid>
              <Grid item md={2} lg={2}>
                <div className="mr-16">
                  <label style={{ visibility: "hidden" }}>Period</label>
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{ mt: 2, height: "25px" }}
                    onClick={() => handleSearch()}
                  >
                    <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
                  </Button>
                </div>
              </Grid>
              <Grid item md={2} lg={2}>
                <div className="mr-12">
                  <label style={{ visibility: "hidden" }}>Period</label>
                  <Button
                    variant="contained"
                    color="warning"
                    size="small"
                    onClick={() => toggleFullScreen()}
                    style={{
                      marginTop: "20px",
                      fontWeight: "bold",
                      height: "25px",
                    }}
                  >
                    View Table
                  </Button>
                </div>
              </Grid>
            </Grid>
          </FormControl>
        </div>
      </Box>
    </>
  );
};

export default NominalLedgerFilter;
